import {UserOPEEnum} from "../UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";


/**
 * O Inner Class
 */
class O {

}


/**
 * I Inner Class
 */
class I {
  id?: number;
  userId?: number;
}


/**
 * GetTransportItemDetailCB class
 */
export class DelUserMetricGroupCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.DelUserMetricGroup);
    this.i = new I();
    this.o = new O();
  }

}
